import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import iconforfvlogo from "../icons/fvlogo.png"; // with import
// import {  Paper } from "@material-ui/core";
import { Helmet } from "react-helmet";
import favicon from "../icons/favicon.ico";

function Copyright(props) {
  return (
    <Grid>
      <Helmet>
        <title>POC</title>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
      <Grid item>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          {...props}
        >
          {"Copyright © "}
          <Link color="inherit" href="https://finvolve.co/">
            Finvolve.co.
          </Link>{" "}
          {new Date().getFullYear()}. All Rights Reserved.
        </Typography>
      </Grid>
      <Grid item>
        {/* <Typography variant="body2" color="text.secondary" align="center">
          <Link color="inherit" href="/wlogin">
            Click here for Finvolve Wealth Manager Login
          </Link>
        </Typography> */}
      </Grid>
    </Grid>
  );
}

const theme = createTheme();

// MAIN FUNCTION FOR THE SINGIN
export default function PasswordReset() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const initialFormData = {password:"", confirmPassword:""}
  const [formData, setFormData] = useState(initialFormData);
  const [errorMessage, seterrorMessage] = useState("");
  const [successMessage, setsuccessMessage] = useState("");
  const finvolveInvestorData = JSON.parse(localStorage.getItem("finvolveInvestorData"));
  // console.log(finvolveInvestorData)
  const handleSubmit = async (event) => {
    event.preventDefault();
    if(formData.password!==formData.confirmPassword){
      seterrorMessage("Password does not match with confirm password")
      return
    }
    if(formData.password.length<5){
      seterrorMessage("Password length less than 5 characters")
      return
    }
    try{
      const response= await fetch(`${API_BASE_URL}/api/investor/${finvolveInvestorData?.email}`,{
        method:"PATCH",
        headers: { "Content-Type": "application/json" },
        body:JSON.stringify({email:finvolveInvestorData?.email, password:formData?.password?.trim()})
      });
      const responseData = await response.json();
      // console.log(responseData)
      if(response?.ok){
        setsuccessMessage("Password Reset Successful")
        seterrorMessage("")
        return
      }
      seterrorMessage(responseData?.error)
      setsuccessMessage("")
    }catch(error){
      // console.log(error)
      seterrorMessage(error.message);
    }

  };

  const handleChange = (e)=>{
    const {name, value} = e.target;
    setFormData({...formData, [name]:value})
    seterrorMessage("")
    setsuccessMessage("")
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
          <Box
            p={4}
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "none",
            }}
          >
            {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}> */}
            {/* <LockOutlinedIcon /> */}
            <img
              src={iconforfvlogo}
              alt="Finvolve Logo"
              style={{
                maxWidth: "180px",
                maxHeight: "180px",
                paddingRight: "0px",
                paddingBottom: "10px",
              }}
            />

            {/* </Avatar> */}
            <Typography component="h1" variant="h5">
              Reset Password
            </Typography>
            {errorMessage.length > 0 && (
              <div style={{ marginBottom: "10px", color: "red" }}>
                {errorMessage}
              </div>
            )}
            {successMessage.length > 0 && (
              <div style={{ marginBottom: "10px", color: "green", textAlign:"center" }}>
                {successMessage} <br />
                <Link href="/investor-dashboard" variant="body2">Go back to Dashboard</Link>
              </div>
            )}
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="New Password"
                name="password"
                autoFocus
                onChange={handleChange}
                type="password"
                value={formData.password}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm New Password"
                type="text"
                id="password"
                onChange={handleChange}
                value={formData.confirmPassword}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={handleSubmit}
                sx={{ mt: 3, mb: 2 }}
              >
                Reset Password
              </Button>
              <Grid container justifyContent={"center"}>
                <Grid item>
                  <Link href="\investor-dashboard" variant="body2">
                    Back to dashboard
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {/* {"Don't have an account? Sign Up"} */}
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
